module.exports = __webpack_public_path__ + "media/ezQ.47724af1.wav";